import { RoleManager } from '@/features/users/ui/RoleManager';

/**
 * §5: a page composes, it does not implement.
 */
export function UsersPage() {
  return <RoleManager />;
}
